/**
 * Primary nav. `Suburbs` is a dropdown — its children live in `SUBURB_LINKS`.
 */
export type NavLink = {
  label: string;
  href: string;
  children?: ReadonlyArray<{ label: string; href: string }>;
  disabled?: boolean;
};

export const NAV_LINKS: ReadonlyArray<NavLink> = [
  { label: 'Home', href: '/' },
  { label: 'About Us', href: '/about' },
  { label: 'Glossary', href: '/glossary' },
  {
    label: 'Suburbs',
    href: '#',
    children: [
      { label: 'Toowoomba City', href: '/suburbs/toowoomba-city' },
      { label: 'Harlaxton', href: '/suburbs/harlaxton' },
      { label: 'Highfields', href: '/suburbs/highfields' },
      { label: 'Gatton', href: '/suburbs/gatton' },
      { label: 'Warwick', href: '/suburbs/warwick' },
      { label: 'Dalby', href: '/suburbs/dalby' },
    ],
  },
  { label: 'Regional Economic Overview', href: '/investment-property' },
  { label: 'Commercial Management', href: '/commercial-management' },
  { label: 'Market Updates', href: '/market-updates' },
  { label: 'FAQ', href: '/faq' },
  { label: 'Contact', href: '/contact-us' },
];

export const SUBURB_LINKS = NAV_LINKS.find((link) => link.label === 'Suburbs')?.children ?? [];
